var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { useQuery } from 'react-query';
import queries from 'constants/queries';
import ApiService from './ApiService';
import { IntegrationConfig } from 'models';
import { plainToInstance } from 'class-transformer';
var IntegrationConfigService = /** @class */ (function (_super) {
    __extends(IntegrationConfigService, _super);
    function IntegrationConfigService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootPath = 'integration_configs';
        return _this;
    }
    IntegrationConfigService.prototype.useIntegrationConfigs = function () {
        var _this = this;
        return useQuery(queries.integrationConfigs, function () { return _this.get(_this.rootPath); }, {
            select: function (_a) {
                var data = _a.data;
                return plainToInstance(IntegrationConfig, data);
            }
        });
    };
    IntegrationConfigService.getInstance = function () {
        if (!IntegrationConfigService.integrationConfigInstance) {
            IntegrationConfigService.integrationConfigInstance = new IntegrationConfigService();
        }
        return IntegrationConfigService.integrationConfigInstance;
    };
    return IntegrationConfigService;
}(ApiService));
export default IntegrationConfigService;
